import dayjs from "dayjs";
import { APIBlobResponse } from "../../../../../../models/NetworkResponse";
import { OrderClientPO } from "../../../../../../models/Order/OrderClientPO";

/** Saves a downloaded client PO PDF, named after the PO number when there is one. */
export const saveClientPOFile = (
  response: APIBlobResponse,
  po: OrderClientPO,
) => {
  if (!response.data) return;
  const blob = new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = po.po_number
    ? `${po.po_number.replace(/\s+/g, "_")}.pdf`
    : response.filename || "Client PO.pdf";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};

export const formatClientPODate = (value?: string | null): string =>
  value && dayjs(value).isValid()
    ? dayjs(value).format("DD MMM YYYY, hh:mm A")
    : "—";
